import { Injectable, inject } from '@angular/core';
import { OpenNativeSettings } from '@awesome-cordova-plugins/open-native-settings/ngx';
import { Capacitor } from '@capacitor/core';
import {
  AndroidSettings,
  IOSSettings,
  NativeSettings,
} from 'capacitor-native-settings';

@Injectable({ providedIn: 'root' })
export class NativeSettingsService {
  private openNativeSettings = inject(OpenNativeSettings);

  isSupported(): boolean {
    return Capacitor.isPluginAvailable('NativeSettings');
  }

  openNotificationSettings(): void {
    if (!this.isSupported()) {
      // Fallback for older native app versions that predate the
      // capacitor-native-settings plugin registration.
      this.openNativeSettings.open('application_details');
      return;
    }
    NativeSettings.open({
      optionAndroid: AndroidSettings.AppNotification,
      optionIOS: IOSSettings.AppNotification,
    });
  }

  openAppSettings(): void {
    if (!this.isSupported()) {
      // Fallback for older native app versions that predate the
      // capacitor-native-settings plugin registration.
      this.openNativeSettings.open('application_details');
      return;
    }
    NativeSettings.open({
      optionAndroid: AndroidSettings.ApplicationDetails,
      optionIOS: IOSSettings.App,
    });
  }
}
